import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  reports: [],
  selectedBank: {
    bank: {
      _id: undefined,
    },
    files: [],
  },
  bankAdded: false,
  bankUpdated: false,
  bankRemoved: false,
};

const banksSlice = createSlice({
  name: "banks",
  initialState,
  reducers: {
    getBanks(state, action) {
      state.list = action.payload.banks;
      state.meta = action.payload.meta;
    },
    getBanksById(state, action) {
      state.selectedBank = action.payload;
    },
    addBanks(state, action) {
      state.bankAdded = true;
    },
    updateBanks(state, action) {
      state.bankUpdated = true;
    },
    removeBanks(state, action) {
      state.bankRemoved = true;
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const banksActions = banksSlice.actions;
export default banksSlice;
